// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/unserneuere-transporteristda-2-2-2/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const unserneuereTransporteristda222DE: PageEntry = {
  id: "post.unserneuere-transporteristda-2-2-2",
  locale: "de",
  slug: "unserneuere-transporteristda-2-2-2",
  seo: {
    title: "Messe productronica in München | Dietz GmbH",
    description: "Messe productronica in München",
  },
  type: "post",
  h1: "Messe productronica in München",
  blocks: [
    { kind: "heading", level: 2, text: "Messe productronica in München" },
    { kind: "paragraph", text: "Auf dem Gemeinschaftsstand von Bayern Innovativ präsentierte unser Vertriebsteam vom 12. bis 15 November unser Produkte und Technologien. Die productronica ist die Weltleitmesse für Entwicklung und Fertigung von Elektronik. Wir möchten uns bei allen Besuchern unseres Messestandes bedanken." }
  ],
};
